<template>
  <ModalFade
    :close-click-outside="closeClickOutside"
    class="mobile-search"
    @close="closeSearch"
  >
    <div class="mobile-search__container">
      <BaseSearch
        auto-focus
        theme="mobile"
        @search="closeSearch"
      />
    </div>
  </ModalFade>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BaseSearch from '~/components/BaseComponents/BaseSearch.vue';
  import ModalFade from '~/components/ModalFade.vue';
  export default defineNuxtComponent({
    name: 'MobileSearch',
    components: {
      BaseSearch,
      ModalFade,
    },

    props: {
      closeClickOutside: {
        type: Boolean as PropType<boolean>,
        default: true,
      },
    },

    methods: {
      closeSearch() {
        this.$emit('close');
      },
    },
  });
</script>

<style lang="scss">
  .mobile-search {
    &__container {
      background: white;
      position: absolute;
      padding: $spacing-1 $spacing-2;
      top: 0;
      left: 0;
      right: 0;
    }
  }
</style>
